import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Button from '../elements/Button';

const propTypes = {
  ...SectionProps.types,
  split: PropTypes.bool
}

const defaultProps = {
  ...SectionProps.defaults,
  split: false
}

const PRICING_API_URL = 'https://api.beta.menur.app/vbeta2/subscriptions/pricing';

const Cta = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  split,
  ...props
}) => {
  const [price, setPrice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(PRICING_API_URL)
      .then((res) => res.json())
      .then((data) => {
        setPrice(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const outerClasses = classNames(
    'section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const sectionHeader = {
    title: 'Preço simples e transparente',
    paragraph: 'Tudo incluído. Sem surpresas.',
  };

  const formatPrice = (amount, currency) => {
    return new Intl.NumberFormat('pt-PT', {
      style: 'currency',
      currency: currency || 'EUR',
    }).format(amount / 100);
  };

  const features = [
    'Produtos e categorias ilimitados',
    'Fotografias de produtos',
    'Cores e marca personalizáveis',
    'Alterações em tempo real',
  ];

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-xs">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div id="price_section" />
          <div className="reveal-from-bottom" style={{ maxWidth: 380, margin: '0 auto' }}>
            <div style={{
              background: 'linear-gradient(145deg, #25282C 0%, #1D2026 100%)',
              borderRadius: 12,
              padding: '40px 32px',
              textAlign: 'center',
              border: '1px solid rgba(255,255,255,0.08)',
            }}>
              <h3 className="mt-0 mb-16 text-color-primary" style={{ fontSize: 20 }}>
                Ementa Digital
              </h3>

              {loading ? (
                <p className="text-sm" style={{ color: '#8A8EA8' }}>A carregar...</p>
              ) : price && price.unit_amount ? (
                <div className="mb-24">
                  <span style={{ fontSize: 44, fontWeight: 700, lineHeight: 1, color: '#ECEDED' }}>
                    {formatPrice(price.unit_amount, price.currency)}
                  </span>
                  <span style={{ fontSize: 14, color: '#8A8EA8' }}> /mês</span>
                </div>
              ) : (
                <div className="mb-24">
                  <p style={{ fontSize: 14, color: '#8A8EA8' }}>
                    Contacte-nos para saber o preço
                  </p>
                </div>
              )}

              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 28px 0', textAlign: 'left' }}>
                {features.map((feature, index) => (
                  <li key={index} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    marginBottom: 10,
                    fontSize: 14,
                    color: '#ECEDED',
                    whiteSpace: 'nowrap',
                  }}>
                    <span className="text-color-primary" style={{ fontWeight: 700, flexShrink: 0 }}>&#10003;</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <Button
                tag="a"
                color="primary"
                wideMobile
                href="https://admin.menur.app/signup"
                style={{ width: '100%' }}
              >
                Experimente grátis 1 mês
              </Button>
              <p style={{ fontSize: 12, color: '#8A8EA8', marginTop: 14, marginBottom: 0 }}>
                Sem cartão de crédito necessário
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

Cta.propTypes = propTypes;
Cta.defaultProps = defaultProps;

export default Cta;
